import { apiGet } from '../../../actions'

interface QueryParams {
  id: string
  from: string
  to: string
  page: number
}

export interface ReportsListResponse {
  data: {
    results: Record<string, unknown>[]
    meta: Record<string, unknown>
  }
}

export const getReports = async ({
  id,
  from,
  to,
  page = 1
}: QueryParams): Promise<ReportsListResponse['data']> => {
  const res = await apiGet<ReportsListResponse>(
    `devices/${id}/reports?from=${from}&to=${to}&pageSize=100&page=${page}`
  )

  return res.data
}
